import React from 'react';
import { ExceptionQueueTable } from '../components/ExceptionQueueTable';

const EXCEPTION_STATUSES = ['No Job Found', 'Received Short', 'On Hold'];

export function ExceptionsPage() {
  return (
    <ExceptionQueueTable
      title="Exceptions"
      subtitle="Scans needing operator action"
      blurb="Open a row to resolve or escalate it in Ace. Escalated items move to Escalations."
      predicate={r => !r.escalated_to_team && EXCEPTION_STATUSES.includes(r.material_status)}
      stageKey="exceptions"
      typeFilters={[
        { id: 'no-job-found',   label: 'No Job Found',   status: 'No Job Found' },
        { id: 'received-short', label: 'Received Short', status: 'Received Short' },
        { id: 'on-hold',        label: 'On Hold',         status: 'On Hold' },
      ]}
    />
  );
}
